/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
import { getUser, removeToken } from "auth/Authentication";
import { User } from "models/user-models";
import { handleRouteRestriction } from "utils/general-utils";
import { useTrialExpiry } from "utils/useTrialExpiry";
import { MdLock } from "react-icons/md";

export const SidebarLinks = (props: { routes: RoutesType[], open?: boolean }): JSX.Element => {
  let location = useLocation();
  const isExpired = useTrialExpiry();

  const { routes, open = true } = props;

  const activeRoute = (routeName: string) => {
    return location.pathname.includes(routeName);
  };

  const createLinks = (routes: RoutesType[]) => {
    const user: User = getUser();
    return routes.map((route, index) => {
      if ((route.layout === "/admin" || route.layout === "/auth" || route.layout === "/rtl") && handleRouteRestriction(user?.type, route.path)) {

        // Disable wizard link when trial/subscription expired
        const isWizardRoute = route.path === "wizard";
        const isDisabled = isExpired && isWizardRoute;

        if (isDisabled) {
          return (
            <div key={index} className="relative mb-3 flex cursor-not-allowed opacity-50" title="Your trial/subscription has expired. Please renew to access this feature.">
              <li className={`my-[3px] flex cursor-not-allowed items-center ${open ? "px-8" : "justify-center px-4"}`}>
                <span className="font-medium text-textSecondary">
                  {route.icon ? route.icon : <DashIcon />}{" "}
                </span>
                <p className={`leading-1 ml-4 flex ${open ? "block" : "hidden"} font-medium text-textSecondary`}>
                  {route.name}
                </p>
                {open && (
                  <MdLock className="ml-auto h-3.5 w-3.5 text-textSecondary" />
                )}
              </li>
            </div>
          );
        }

        return (
          <Link key={index} to={route.layout + "/" + route.path} onClick={() => {
            if (route.path === "logout") {
              removeToken();
            }
          }}>
            <div className="relative mb-3 flex hover:cursor-pointer">
              <li
                className={`my-[3px] flex cursor-pointer items-center ${open ? "px-8" : "justify-center px-4"}`}
                key={index}
              >
                <span
                  className={`${activeRoute(route.path) === true
                    ? "font-bold text-brand-500"
                    : "font-medium text-textSecondary hover:text-textPrimary"
                    }`}
                >
                  {route.icon ? route.icon : <DashIcon />}{" "}
                </span>
                <p
                  className={`leading-1 ml-4 flex ${open ? "block" : "hidden"} ${activeRoute(route.path) === true
                    ? "font-bold text-textPrimary"
                    : "font-medium text-textSecondary hover:text-textPrimary"
                    }`}
                >
                  {route.name}
                </p>
              </li>
              {activeRoute(route.path) ? (
                <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500" />
              ) : null}
            </div>
          </Link>
        );
      }
    });
  };

  return <>{createLinks(routes)}</>;
};

export default SidebarLinks;
